import { render, staticRenderFns } from "./homeSolve.vue?vue&type=template&id=9e9bc90c&scoped=true"
import script from "./homeSolve.vue?vue&type=script&lang=js"
export * from "./homeSolve.vue?vue&type=script&lang=js"
import style0 from "./homeSolve.vue?vue&type=style&index=0&id=9e9bc90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9bc90c",
  null
  
)

export default component.exports